document.addEventListener('DOMContentLoaded', () => {
  const root = document.getElementById('DBT');
  if (!root) return;

  const animatedElements = root.querySelectorAll('.anime');
  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        entry.target.classList.toggle('active', entry.isIntersecting);
      });
    }, { threshold: 0.1 });

    animatedElements.forEach((element) => observer.observe(element));
  } else {
    animatedElements.forEach((element) => element.classList.add('active'));
  }
});
